export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('lignesCommande') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Libelle') {
      return {
        message: 'validationFacture.name.libelleLigneCommande',
      };
    }
    if (libellePropriete === 'Quantite') {
      return i18n.t('validationFacture.name.quantiteLigneCommande');
    }
    if (libellePropriete === 'PrixUnitaire') {
      return i18n.t('validationFacture.name.prixUnitaireLigneCommande');
    }
    if (libellePropriete === 'Remise') {
      return i18n.t('validationFacture.name.remiseLigneCommande');
    }
    if (libellePropriete === 'TauxTva') {
      return {
        message: 'validationFacture.name.tauxTvaLigneCommande',
      };
    }
    if (libellePropriete.indexOf('LignesCommande') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Quantite') {
        return i18n.t('validationFacture.name.quantiteLigneCommande');
      }
      if (libellePropriete === 'PrixUnitaire') {
        return i18n.t('validationFacture.name.prixUnitaireLigneCommande');
      }
      if (libellePropriete === 'Remise') {
        return i18n.t('validationFacture.name.remiseLigneCommande');
      }
    }
    if (libellePropriete.indexOf('LignesRemise') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Remise') {
        return i18n.t('validationFacture.name.remise');
      }
    }
    if (libellePropriete.indexOf('LigneCommandeDispositif') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'NomDispositif') {
        return i18n.t('validationFacture.name.nomDispositif');
      }
      if (libellePropriete === 'MaterielTypeId') {
        return i18n.t('validationFacture.name.materielTypeId');
      }
      if (libellePropriete === 'DispositifTypeId') {
        return i18n.t('validationFacture.name.dispositifTypeId');
      }
      if (libellePropriete === 'MaterielFormatId') {
        return i18n.t('validationFacture.name.materielFormatId');
      }
    }
    return libellePropriete;
  }

  if (propriete.indexOf('intervenant') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Repartition') {
      return i18n.t('validationDevis.name.repartitionIntervenant');
    }

    if (libellePropriete === 'tiersId') {
      return {
        message: 'validationFacture.name.tiersId',
      };
    }
  }
  if (propriete.indexOf('echeancierPaiement') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'dateEcheance') {
      return i18n.t('validationFacture.name.dateEcheance');
    }
    if (libellePropriete === 'montant') {
      return i18n.t('validationFacture.name.montant');
    }
  }
  if (propriete.indexOf('echeanciersPaiement') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'dateEcheance') {
      return i18n.t('validationFacture.name.dateEcheance');
    }
    if (libellePropriete === 'montant') {
      return i18n.t('validationFacture.name.montant');
    }
  }
  if (propriete === 'assistantId') {
    return i18n.t('validationFacture.name.assistant');
  }
  if (propriete === 'commercialId') {
    return i18n.t('validationFacture.name.commercial');
  }
  if (propriete === 'dateDevisCommande') {
    return {
      message: 'validationFacture.name.dateDevisCommande',
    };
  }

  if (propriete === 'dateValidite') {
    return {
      message: 'validationFacture.name.dateValidite',
    };
  }

  if (propriete === 'datePremiereEcheance') {
    return {
      message: 'validationFacture.name.datePremiereEcheance',
    };
  }
  if (propriete === 'nombreEcheances') {
    return {
      message: 'validationFacture.name.nombreEcheances',
    };
  }
  if (propriete === 'codeMandataire') {
    return i18n.t('validationFacture.name.codeMandataire');
  }
  return propriete;
}
